import React from 'react'
import { Grid, Box, Skeleton } from '@mui/material'

const MakePaymentSkeleton = () => (
  <Grid container>
    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
      <Box p={2}>
        <Skeleton width={180} height={24} />
        <Box mt={1}>
          <Skeleton variant="rectangular" height={48} />
        </Box>
      </Box>
    </Grid>
    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
      <Box p={2}>
        <Skeleton width={180} height={24} />
        <Box mt={1}>
          <Skeleton variant="rectangular" height={48} />
        </Box>
      </Box>
    </Grid>
    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
      <Box p={2}>
        <Skeleton variant="rectangular" height={120} />
      </Box>
    </Grid>
    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
      <Box p={2}>
        <Skeleton variant="rectangular" height={120} />
      </Box>
    </Grid>
    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
      <Box p={2}>
        <Skeleton variant="rectangular" height={56} />
      </Box>
    </Grid>
  </Grid>
)

export default MakePaymentSkeleton
